export interface Review {
  name: string;
  avatar: string,
  quote: string,
  rating: number,
  status: string,
  title: string,
  id: string,
  
}

export class Review implements Review{}
